import PropTypes from "prop-types";
import React from "react";
import {MSpinner} from "components/Shared";
import { reduxForm, Field } from "redux-form";
import Button from "@mui/material/Button";
import InputField from "components/FormElements/InputField";
import { validatePrivateNotes } from "validations";

const PrivateNotes = ({
  isFetching,
  updatePrivateNotes,
  // provided by redux-form
  handleSubmit,
  invalid,
  pristine,
  submitting,
  initialValues
}) => {

  if (isFetching) {
    return <MSpinner/>;
  }

  if (!initialValues) {
    return <MSpinner/>;
  }

  return (
    <div className="case-header md-grid">
      <p>For internal use.  Won't appear on client reports or documents.</p>
      <div className="md-cell--12">
        <form onSubmit={handleSubmit(updatePrivateNotes)}>
        <Field
          id="notes"
          name="notes"
          rows={3}
          component={InputField}
          disabled={(initialValues && initialValues.isReadOnly) === true}
          type="text"
          hintText="Private Notes"
          dataTest="private-notes"
        />
        <div className="md-grid md-grid--no-spacing">
          <div className="md-cell--6 md-cell--4-tablet md-cell--2-phone">
            <Button
              type="submit"
              disabled={invalid || pristine || submitting}
              className="m-t-10 save"
              data-test="save"
            >Save</Button>
          </div>
        </div>
      </form>
    </div>
    </div>);
};


PrivateNotes.propTypes = {
  isFetching: PropTypes.bool.isRequired,
  updatePrivateNotes: PropTypes.func.isRequired,
  // provided by redux-form
  handleSubmit: PropTypes.func.isRequired,
  invalid: PropTypes.bool.isRequired,
  pristine: PropTypes.bool.isRequired,
  submitting: PropTypes.bool.isRequired,
  initialValues: PropTypes.object.isRequired,
};

export default (reduxForm({
  form: "PrivateNotes",
  validate: validatePrivateNotes
}))(PrivateNotes);